<script lang="ts" setup>
import { useSubmittedDocument } from "~/stores/useSubmittedDocument";

import { DocumentViewMode } from "~/types/enums/DocumentViewMode.enum";

const props = defineProps({
  documentId: {
    type: String,
    required: true,
  },
  mode: {
    type: String as PropType<DocumentViewMode>,
    required: true,
  },
  isCompanionMode: {
    type: Boolean,
    required: false,
    default: false,
  },
});

const emit = defineEmits(["onSubmitted"]);

provide("documentId", props.documentId);

const docStore = useSubmittedDocument(props.documentId)();
const documentToCompareStore = useDocumentToCompareStore(props.documentId);
const documentClassroomDataStore = useDocumentClassroomDataStore(
  props.documentId
);

const isInitialized = ref(false);
onMounted(async () => {
  try {
    await docStore.initialize(props.documentId, props.mode as DocumentViewMode);
    await documentToCompareStore.initialize();
    await documentClassroomDataStore.initialize();
    await documentClassroomDataStore.initialize();

    isInitialized.value = true;
  } catch (error: any) {
    if (error.message == "Missing or insufficient permissions.") {
      throw createError({
        statusCode: 403,
        message: "You are not authorized to access this submission.",
        data: {
          title: "Oops!",
          message: "You are not authorized to access this submission.",
        },
      });
    }

    throw error;

    isInitialized.value = false;
  }
});
</script>

<template>
  <div class="w-full h-full">
    <BaseLoading v-if="isInitialized != true" class="h-full" />
    <DocumentContainer
      v-if="isInitialized"
      :document-id="documentId"
      :is-companion-mode="isCompanionMode"
      @on-submitted="
        () => {
          emit('onSubmitted');
        }
      "
    >
      <template #app-bar="{ submittedDocument }">
        <slot name="app-bar" :submittedDocument="submittedDocument" />
      </template>
    </DocumentContainer>
  </div>
</template>

<style scoped></style>
